<template>
  <Modal v-model="show">
    <div
      slot="header"
      width="300">
      <span>权限申请</span>
    </div>
    <div>
      <h4 class="item">表字段</h4>
      <div class="tableContainer"><Table size="small"  border :columns="columns" :data="datas" @on-selection-change='handleSelect'></Table></div>
      <h4 class="item">申请理由</h4>
      <div class="reason">
        <Input v-model="remark" type="textarea" :autosize="{minRows: 3,maxRows: 10}" placeholder="申请理由，什么租户，什么需求场景，描述清楚价值后点击提交申请" />
      </div>
    </div>
    <div slot="footer">
      <Button @click="close()">{{ $t('message.constants.cancel') }}</Button>
      <Button
        type="primary"
        @click="submit()">{{ $t('message.constants.submit') }}</Button>
    </div>
  </Modal>
</template>
<script>
import storage from "@dss/js/helper/storage";
import {axios} from "@/api";
export default {
  name: 'ApplyRightDialog', 
  props: {    
    columnDatas: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: false,
      remark:'',
      selections:[],
      columns:[
        {
          type: 'selection',
          width: 60,
          align: 'center',
          key:'id'
        },
        {
          title: '字段名',
          key: 'name'
        },
        {
          title: '字段类型',
          key: 'type'
        }
      ],
    }
  },
  computed: {
    datas() {
      return JSON.parse(JSON.stringify(this.columnDatas));
    },
  },
  methods: {
    handleSelect(selection){
      this.selections=selection;
      console.log(this.selections);
      
    },
    open(columnDatas) {      
      this.remark = '';
      this.show = true; 
      this.sendTrack([{ pageId: 22, buttonId: 153, type: "show" },{ pageId: 22, buttonId: 154, type: "show" }]);     
    },
    close() {
      this.show = false;
      this.remark = ''; 
      this.sendTrack([{ pageId: 22, buttonId: 154, type: "click" }]);     
    },
    submit() {
      this.sendTrack([{ pageId: 22, buttonId: 153, type: "click" }]);
      let user = localStorage.getItem('userId');
       if (this.selections.length && this.remark.trim() && user) {
        this.handleApplyPermission();
      } else if (!this.selections.length) {
        this.$Message.warning("请选择至少一个申请字段");
      } else if (!this.remark.trim()) {
        this.$Message.warning("请填写申请理由");
      } else {
        this.$Message.warning("该租户owner不存在，无法提交申请");
      }
    },
      async handleApplyPermission() {
      //提交申请
      let wps = JSON.parse(localStorage.getItem('workspacesInfo'));
      let workspaceId =  Number(storage.get('bdp-user-workspace-id','cookie'));
      let user = wps.find(item =>item.id == workspaceId).createBy;
      let resources = [];
      this.selections.forEach(item => {
        resources.push({ user, resourceKey: item.id });
      });
      let { status, data, message } = await axios({
        method: "POST",
        url: `/api/rest_j/v1/acl/apply/permission/resource`,
        data: {
          resources,
          workspaceId, //workspaceId需为数字类型
          remark:this.remark
        }
      }).catch(err => {
        console.log(err);
      });
      if (status == 0) {
        let applied = data && data.applied ? data.applied : [];
        if (applied.length) {
          let flag = true;
          resources.forEach((item, index) => {
            if (!applied.includes(item.resourceKey)) {
              flag = false;
            }
          });
          if (flag) {
            this.$Notice.warning({
              title: "申请结果",
              desc: "您已申请过这些字段，可以在“我的申请”里查看审核结果",
               duration:5
            });
          } else {
            this.$Message.success("申请成功，等待审核！");
            setTimeout(() => {
              this.$router.push("/myApply");
            }, 2000);
          }
        } else {
          this.$Message.success("申请成功，等待审核！");
          setTimeout(() => {
            this.$router.push("/myApply");
          }, 2000);
        }
      } else {
        message && this.$Message.warning({duration:0,closable: true,content:message});
      }
    }  
  },
};
</script>
<style lang="css">
  .tableContainer{
    max-height: 350px;
    overflow: auto;
    margin-bottom: 10px;
  }
</style>